import React from "react";
import { Link } from "react-router-dom";

const PitchItemHorizontal = ({
  id,
  slug,
  name,
  location,
  price,
  status,
  showBookingsButton = true,
}) => {
  return (
    <div
      className={`flex items-center justify-between px-1 py-4 sm:p-4 rounded-lg shadow-md bg-white w-full transition-all border pih ${
        status === "active" ? "border-green-500" : "border-red-500 opacity-80"
      }`}
    >
      {/* Pitch Info */}
      <div>
        <Link to={`/sahalar/${slug}`}>
          <h2 className="text-[12px] sm:text-lg font-semibold text-gray-800 hover:underline">
            {name}
          </h2>
        </Link>
        <p className="text-[10px] sm:text-sm text-gray-600">{location}</p>
      </div>

      {/* Status & Actions */}
      <div className="flex items-center gap-2 sm:gap-4">
        <span
          className={`hidden sm:inline-block px-3 py-1 text-sm font-medium rounded-full ${
            status === "active"
              ? "bg-green-100 text-green-600"
              : "bg-red-100 text-red-600"
          }`}
        >
          {status === "active" ? "Aktif" : "Kapalı"}
        </span>

        <span className="text-[12px] sm:text-sm sm:text-lg font-semibold text-[#4d9041]">
          ₺{price}/saat
        </span>

        {showBookingsButton && (
          <Link to={`/kiralamalar/${slug}`}>
            <button className="bg-[#4d9041] hover:bg-[#62a556] text-white px-1 py-2 sm:px-4 sm:py-2 rounded-lg text-[10px] sm:text-sm font-medium cursor-pointer">
              Rezervasyonlar
            </button>
          </Link>
        )}
      </div>
    </div>
  );
};

export default PitchItemHorizontal;
